import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlEndPoints } from '../config/end-points';
import { Profile } from '../models/profile.model';
import { SurgeonOpening } from '../models/surgeonOpenings.model';

@Injectable({
  providedIn: 'root',
})
export class SurgeonOpeningsDal {
  constructor(private httpClient: HttpClient) {}

  getAllSOByWeek(
    startDate: string,
    endDate: string,
    specialties?: string,
    scenario?: string,
    campaign?: string
  ): Observable<Profile[]> {
    return this.httpClient.get<any>(
      `${urlEndPoints.openings}getByWeek/?startDate=${startDate}&endDate=${endDate}&specialties=${specialties}&scenario=${scenario}&campaign=${campaign}`
    );
  }

  getSurgeons(_id: string, date: string): Observable<Profile[]> {
    return this.httpClient.get<any>(`${urlEndPoints.openings}room/${_id}?date=${date}`);
  }

  getSurRHRec(profileId: string, startDate: string, endDate: string): Observable<any> {
    return this.httpClient.get<any>(
      `${urlEndPoints.openings}openingRecap?surgeonId=${profileId}&fromDate=${startDate}&toDate=${endDate}`
    );
  }

  updateSimpleDayNeeds(surgeonOpenings: any, isTvo: boolean = false): Observable<Profile[]> {
    return this.httpClient.post<any>(`${urlEndPoints.openings}simpleDayNeeds?isTvo=${isTvo}`, surgeonOpenings);
  }

  getNeeds(date: string): Observable<any> {
    return this.httpClient.get<any>(`${urlEndPoints.openings}needsByOpenings?date=${date}`);
  }

  getWeekOpenings(surgeonId: string, date: string): Observable<SurgeonOpening[]> {
    return this.httpClient.get<SurgeonOpening[]>(`${urlEndPoints.openings}surgeon/${surgeonId}?date=${date}`);
  }

  getProfilesOpenings(fromDate: string, toDate: string, body: { profiles: string[] }) {
    return this.httpClient.post<SurgeonOpening[]>(
      `${urlEndPoints.openings}surgeons/${fromDate}?toDate=${toDate}`,
      body
    );
  }

  updateManySO(profile: Profile, fromDate: string, toDate: string, body: any): Observable<SurgeonOpening[]> {
    return this.httpClient.post<SurgeonOpening[]>(
      `${urlEndPoints.openings}createOrUpdateMany?surgeonId=${profile._id}&fromDate=${fromDate}&toDate=${toDate}`,
      body
    );
  }

  modifySurgeonOpeningNeed(surgeonOpeningId: string, needs: any): Observable<any> {
    return this.httpClient.post<any>(`${urlEndPoints.openings}modifySurgeonOpeningNeeds`, { surgeonOpeningId, needs });
  }

  checkExistence(startDate: string, endDate: string, concernedRooms: any): Observable<any> {
    return this.httpClient.post<any>(`${urlEndPoints.openings}checkExistence`, { startDate, endDate, concernedRooms });
  }

  getFromDataExtraction(fromDate: string, toDate: string): Observable<any> {
    return this.httpClient.get<any>(
      `${urlEndPoints.openings}getFromDataExtraction?fromDate=${fromDate}&toDate=${toDate}`
    );
  }

  getLastUpdateDate(date: string): Observable<any> {
    return this.httpClient.get<any[]>(urlEndPoints.openings + 'lastUpdateDate?date=' + date);
  }

  saveSchedulingPDF(
    schedulingData: any,
    weekDays: any,
    formationsGroups: any,
    roomsName: any,
    displayCodes: boolean,
    showRoles?: boolean,
    isBasicService?: boolean,
    reverseNameOrder?: boolean,
    showRMColor?: boolean
  ): Observable<Blob> {
    return this.httpClient.post(
      urlEndPoints.openings + 'saveSchedulingPDF',
      {
        schedulingData,
        weekDays,
        formationsGroups,
        roomsName,
        displayCodes,
        showRoles,
        isBasicService,
        reverseNameOrder,
        showRMColor,
      },
      {
        responseType: 'blob',
      }
    );
  }
}
